import "./App.css";
import Board from "./component/Board";

function App() {
  return (
    <div className="App">
      <h2>Minesweeper Game</h2>
      <Board />
    </div>
  );
}

export default App;
